module.exports = "/_next/static/images/csv-cd85469a427d936955ebf0a079ebc75f.svg";